module.exports = __WEBPACK_EXTERNAL_MODULE_16__;


//////////////////
// WEBPACK FOOTER
// external "angular-sanitize"
// module id = 16
// module chunks = 0